/* eslint-disable import/no-extraneous-dependencies */
import React, { useMemo } from 'react';
import { Marker } from '@react-google-maps/api';
import { Clusterer } from '@react-google-maps/marker-clusterer';
import Model from '@tripian/model';

interface IGMarkerProviderStorageBase {
  coordinate: Model.Coordinate;
  animation?: 1 | 2;
  clusterer?: Clusterer;
  markerStorageClicked: () => void;
  isFocused?: boolean;
}

const GMarkerProviderStorageBase: React.FC<IGMarkerProviderStorageBase> = ({ coordinate, animation, clusterer, markerStorageClicked, isFocused = false }) => {
  const baseSvgIcon = `<svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50">
  <defs>
    <image id="img1" width="37" height="50" href="data:image/png;base64,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"/>
  </defs>
  <circle cx="25" cy="25" r="25" fill="#fff"/>
  <use href="#img1" transform="matrix(.778,0,0,.778,11.194,5)"/>
</svg>
`;

  const svgDataUri = useMemo(() => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(baseSvgIcon)}`, [baseSvgIcon]);
  const markerIcon = useMemo(
    () => ({
      url: svgDataUri,
      scaledSize: new window.google.maps.Size(isFocused ? 42 : 40, isFocused ? 42 : 40),
    }),
    [svgDataUri, isFocused],
  );

  return (
    <Marker
      position={coordinate}
      icon={markerIcon}
      onClick={() => {
        markerStorageClicked();
      }}
      animation={animation}
      clusterer={clusterer}
    />
  );
};

export default GMarkerProviderStorageBase;
